module.exports = __webpack_public_path__ + "public/img/mobile-banner.7afd6356.svg";